var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginFlower = function SvgLoginFlower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 130,
    viewBox: "0 0 36 130"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#454154",
    d: "M27 162V37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 36,
    r: 9,
    fill: "#454154"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#8b688d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454154",
    d: "M26 72S24.79 45.13 0 48.253"
  }))));
};
export default SvgLoginFlower;